var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
import React from 'react';
import ReactCollapse from 'react-bootstrap/Collapse';
import classnames from 'classnames';
var HOCollapse = /** @class */function (_super) {
  __extends(HOCollapse, _super);
  function HOCollapse() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      isOpen: _this.props.isOpen
    };
    _this.toggleIsOpen = function () {
      _this.setState({
        isOpen: !_this.state.isOpen
      });
    };
    return _this;
  }
  HOCollapse.prototype.componentWillReceiveProps = function (nextProps) {
    if (nextProps.isOpen !== this.props.isOpen) {
      this.setState({
        isOpen: nextProps.isOpen
      });
    }
  };
  HOCollapse.prototype.render = function () {
    var isOpen = this.state.isOpen;
    var _a = this.props,
      children = _a.children,
      buttonText = _a.buttonText;
    var classNames = classnames('text-red collapse-button', {
      open: isOpen
    });
    return React.createElement(React.Fragment, null, React.createElement("strong", {
      className: classNames,
      onClick: this.toggleIsOpen
    }, React.createElement("i", {
      className: 'fas fa-chevron-right mr-2'
    }), buttonText), React.createElement(ReactCollapse, {
      in: isOpen
    }, React.createElement("div", null, children)));
  };
  return HOCollapse;
}(React.Component);
export { HOCollapse };